export enum LevelColors {
  SILENT = "black",
  INFO = "darkturquoise",
  WARN = "khaki",
  ERROR = "tomato",
}
